import { AbstractControl } from '@angular/forms';

export default function mod10(control: AbstractControl) {
  const errorObject = {
    mod10: true,
  };

  if (!control || !control.value || control.value.length !== 9) {
    return null;
  }

  const abaRoutingNumberCheckSum = (routingNumberDigits: number[]): boolean => {
    const firstGroupSum =
      routingNumberDigits[0] + routingNumberDigits[3] + routingNumberDigits[6];
    const secondGroupSum =
      routingNumberDigits[1] + routingNumberDigits[4] + routingNumberDigits[7];
    const thirdGroupSum =
      routingNumberDigits[2] + routingNumberDigits[5] + routingNumberDigits[8];

    const totalCheckSum =
      3 * firstGroupSum + 7 * secondGroupSum + thirdGroupSum;
    const divisibleBy10 = totalCheckSum % 10 === 0;
    return divisibleBy10;
  };

  const isValid = abaRoutingNumberCheckSum(control.value.split('').map(Number));
  return isValid ? null : errorObject;
}
